import { Form } from 'react-bootstrap'

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl } = props;
    return (
        <>
            <Form.Group controlId="privacyConsent">
                <span>Ausführliche Informationen zur Verarbeitung deiner personenbezogenen Daten im Rahmen des Bewerbungsverfahrens findest du in unserer <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >Datenschutzerklärung</a>.</span>
            </Form.Group>
        </>
    );
};